import * as React from "react";

import Button from "../components/common/PressableButton";
import {
  spacing,
  Title,
  Space,
  Divider,
  Label,
  TextInput,
  SubHeader,
  Paragraph,
} from "../styled-component";
import styled from "styled-components/native";
import Modal from "../components/common/Modal";

const ComponentsContainer = styled.View`
  ${spacing}
`;

function ComponentsDemo() {
  const [isVisible, setIsVisible] = React.useState(false);

  return (
    <ComponentsContainer>
      <Title>mnUvr components</Title>

      <Space />

      <Divider />

      <Space />

      <SubHeader>buttons</SubHeader>

      <Button title="Primary & Contained" />

      <Space />

      <Button title="Primary & Outlined" mode="outlined" />

      <Space />

      <Button title="Primary & Text" mode="text" />

      <Space />

      <Button title="Accent & Contained" color="accent" />

      <Space />

      <Button title="Accent & Outlined" mode="outlined" color="accent" />

      <Space />

      <Button title="Accent & Text" mode="text" color="accent" />

      <Space />

      <Divider />

      <Space />

      <SubHeader>inputs</SubHeader>

      <Space />

      <Label>text input</Label>

      <TextInput />

      <Space />

      <Divider />

      <Space />

      <SubHeader>modals</SubHeader>

      <Space />

      <Button
        title={isVisible ? "hide modal" : "show modal"}
        onPress={() => setIsVisible(true)}
      />

      <Modal
        title="It was popularised in the 1960s with the release of Letraset"
        isVisible={isVisible}
        onDismiss={() => setIsVisible(false)}
        primaryAction={
          <Button title="confirm" onPress={() => setIsVisible(false)} greedy />
        }
        content={
          <Modal.Content>
            <Paragraph>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop publishing software like Aldus PageMaker including
              versions of Lorem Ipsum.
            </Paragraph>

            <Paragraph>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop publishing software like Aldus PageMaker including
              versions of Lorem Ipsum.
            </Paragraph>
          </Modal.Content>
        }
      />
    </ComponentsContainer>
  );
}

export default ComponentsDemo;
